(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-open-draw-defined.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-open-draw-defined.js');

'use strict';

const clx = svs.components.lbUtils.clx;
const _svs$components$marke = svs.components.marketplaceCompetition.overviewHero.common,
  CompetitionLogo = _svs$components$marke.CompetitionLogo,
  LoginButton = _svs$components$marke.LoginButton,
  Registration = _svs$components$marke.Registration;
const resolveCompetitionName = svs.components.marketplaceCompetition.helpers.resolveCompetitionName;
const _svs$components$marke2 = svs.components.marketplaceCompetition.overviewHero.constants.OverviewUserState,
  IS_NOT_REGISTERED = _svs$components$marke2.IS_NOT_REGISTERED,
  HAS_NO_CURRENT_BET = _svs$components$marke2.HAS_NO_CURRENT_BET,
  HAS_CURRENT_BET = _svs$components$marke2.HAS_CURRENT_BET;
const UserNotLoggedIn = _ref => {
  let competition = _ref.competition,
    compName = _ref.compName;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "".concat(compName, " \xE4r h\xE4r!"))), React.createElement("p", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "Var med och sl\xE5ss om titeln")), React.createElement(LoginButton, {
    isVisible: true
  })));
};
const UserNotRegistered = _ref2 => {
  let competition = _ref2.competition,
    compName = _ref2.compName;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "".concat(compName, " \xE4r h\xE4r!"))), React.createElement("p", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "Anm\xE4l dig till t\xE4vlingen")), React.createElement(Registration, {
    competition: competition
  })));
};
const UserHasNoBet = _ref3 => {
  let competition = _ref3.competition,
    compName = _ref3.compName;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "Du deltar i ".concat(compName))), React.createElement("p", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "F\xF6rsta omg\xE5ngen \xF6ppnar snart f\xF6r spel."))));
};
const UserHasBet = _ref4 => {
  let competition = _ref4.competition,
    compName = _ref4.compName;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "Du deltar i ".concat(compName)))));
};
const CompetitionOpenDrawDefined = _ref5 => {
  let competition = _ref5.competition,
    userState = _ref5.userState;
  const compName = resolveCompetitionName(competition);
  const renderContentBasedOnUserState = state => {
    switch (state) {
      case IS_NOT_REGISTERED:
        return React.createElement(UserNotRegistered, {
          competition: competition,
          compName: compName
        });
      case HAS_NO_CURRENT_BET:
        return React.createElement(UserHasNoBet, {
          competition: competition,
          compName: compName
        });
      case HAS_CURRENT_BET:
        return React.createElement(UserHasBet, {
          competition: competition,
          compName: compName
        });
      default:
        return React.createElement(UserNotLoggedIn, {
          competition: competition,
          compName: compName
        });
    }
  };
  return React.createElement("div", {
    className: clx('competition-overview-hero competition-open-draw-defined', userState)
  }, renderContentBasedOnUserState(userState));
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.content.CompetitionOpenDrawDefined', CompetitionOpenDrawDefined);

 })(window);